// extracted by mini-css-extract-plugin
module.exports =  {"avatar":"_93444fe79c--avatar--ceW9Q","clickable":"_93444fe79c--clickable--jjxbB","company":"_93444fe79c--company--MXKHY"};